import * as Immutable from "immutable";
import VisualizationConfig from "./VisualizationConfig";
export default class NumberVisualizationConfig extends VisualizationConfig {
  constructor(trend, trendPreference, alignment = void 0) {
    super();
    this._value = { trend, trendPreference, alignment };
  }
  get trend() {
    return this._value.trend;
  }
  get trendPreference() {
    return this._value.trendPreference;
  }
  get alignment() {
    return this._value.alignment;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(trend = false, trendPreference = "NEUTRAL", alignment = void 0) {
    return new NumberVisualizationConfig(trend, trendPreference, alignment);
  }
  static empty() {
    return NumberVisualizationConfig.create(false, "NEUTRAL");
  }
  toJSON() {
    const { trend, trendPreference, alignment } = this._value;
    return {
      trend,
      trend_preference: trendPreference,
      alignment
    };
  }
  equalsForSearch(other) {
    return other && "trend" in other && other.trend === this.trend;
  }
  static fromJSON(_type, value) {
    const { trend, trend_preference: trendPreference, alignment } = value;
    return NumberVisualizationConfig.create(trend, trendPreference, alignment);
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  trend(value) {
    return new Builder(this.value.set("trend", value));
  }
  trendPreference(value) {
    return new Builder(this.value.set("trendPreference", value));
  }
  alignment(value) {
    return new Builder(this.value.set("alignment", value));
  }
  build() {
    const { trend, trendPreference, alignment } = this.value.toObject();
    return new NumberVisualizationConfig(trend, trendPreference, alignment);
  }
}
